// extracted by mini-css-extract-plugin
export default {"wrapper":"Preloader_wrapper__hcK2M","loader":"Preloader_loader__-6wDD"};